import { i18n, Translations } from "@i18n";
import { InProgressBanner } from "@routes/DashboardRoute/AccountStatusSection/InProgressBanner";
import { Intercom } from "@services";

export const VerificationInProgressBanner = () => {
  const handleContactSupport = () => {
    Intercom.showChat();
  };

  return (
    <InProgressBanner
      title={i18n.t(Translations.AccountVerificationInProgressTitle)}
      subtitle={i18n.t(Translations.AccountVerificationInProgressSubtitle)}
      ctaTitle={i18n.t(Translations.AccountVerificationInProgressSupport)}
      ctaOnClick={handleContactSupport}
    />
  );
};
